export var PopoverComponentType;
(function (PopoverComponentType) {
    PopoverComponentType["DIV"] = "div";
    PopoverComponentType["DIALOG"] = "dialog";
    PopoverComponentType["SPAN"] = "span";
})(PopoverComponentType || (PopoverComponentType = {}));
//# sourceMappingURL=component.js.map